import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSearch } from '../SearchContext';
import { useFilter } from '../FilterContext';
import FilterDrawer from './FilterDrawer';
import { decryptToken } from './utils/getToken';

const UserRecords = () => {

    const token = decryptToken("accessToken") || ""
    const encrypted = getDecryptedUserFromCookie("gta_mainstateuser");
    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [customer, setCustomer] = useState([])
    const urlmain = API_BASE_URL
    const navigate = useNavigate()
    const [customers, setCustomers] = useState([
        // Sample data (replace with actual data)
        {
            photo: 'https://via.placeholder.com/50',
            name: 'John Doe',
            attendance: '95%',
            center: 'ABC Institute',
            level: 'Advanced',
            age: 22,
            date: '2023-11-25'
        },
        {
            photo: 'https://via.placeholder.com/50',
            name: 'Jane Smith',
            attendance: '85%',
            center: 'XYZ Academy',
            level: 'Intermediate',
            age: 24,
            date: '2023-11-20'
        },
        {
            photo: 'https://via.placeholder.com/50',
            name: 'Alice Brown',
            attendance: '90%',
            center: 'Tech Solutions',
            level: 'Beginner',
            age: 20,
            date: '2023-11-18'
        },
    ]);
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const { globalSearch } = useSearch();
    const { entriesPerPage, sortOrder, showDrawer, setShowDrawer, customDate } = useFilter();
    const [load, setLoad] = useState(false);

    const fetchDataUser = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${urlmain}/registeruser/getdata/${encrypted.main_id}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            })
            const res = await response.json();
            setCustomer(res);
        } catch (error) {
            console.error(error)
        } finally {
            setLoad(false)
        }
    }

    const toggleActive = async (index, userId) => {
        try {
            const response = await fetch(`${urlmain}/registeruser/toggle-status/${userId}`, {
                method: 'PATCH',
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            });

            const result = await response.json();

            if (!result.isError) {

                const updated = customer.map(cust =>
                    cust.id === userId ? { ...cust, status: result.status } : cust
                );
                toast.success(result.message)
                setCustomer(updated);
            } else {
                toast.error(result.message)
            }
        } catch (error) {
            toast.error(error)
        }
    };

    const deleteUserRecord = async (row) => {
        const label = row.full_name || row.email || row.user_id || "this user";
        if (!window.confirm(`Delete ${label}? This cannot be undone.`)) return;

        try {
            const response = await fetch(`${urlmain}/registeruser/${row.id}`, {
                method: "DELETE",
                credentials: "include",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const result = await response.json().catch(() => ({}));

            if (response.ok && !result.isError) {
                toast.success(result.message || "User deleted");
                setCustomer((prev) => prev.filter((c) => c.id !== row.id));
            } else {
                toast.error(result.message || "Failed to delete user");
            }
        } catch (err) {
            console.error(err);
            toast.error("Failed to delete user");
        }
    };


    let filteredUsers = [...customer];


    // 1. Filter by date
    if (customDate.from || customDate.to) {
        filteredUsers = filteredUsers.filter((user) => {
            const createdAt = new Date(user.createdAt);
            const from = customDate.from ? new Date(customDate.from) : null;
            const to = customDate.to ? new Date(customDate.to) : null;

            return (!from || createdAt >= from) && (!to || createdAt <= to);
        });
    }

    // 2. Sort by date
    filteredUsers.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

    // 3. Apply global search
    filteredUsers = filteredUsers.filter((user) =>
        Object.values(user).some((value) =>
            String(value).toLowerCase().includes(globalSearch.toLowerCase())
        )
    );

    // 4. Pagination
    const totalPages = Math.ceil(filteredUsers.length / entriesPerPage);
    const currentData = filteredUsers.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);



    useEffect(() => {
        fetchDataUser();
    }, [])

    if (load) {
        return (
            <div className="loader-wrapper-hbtreal">
                <div className="spinner-hbtreal"></div>
                <p className="loader-text-hbtreal">Loading, Please Wait...</p>
            </div>
        );
    }

    return (
        <>
            <div className="customers-header">
                <h1 className="dashboard-title">User records</h1>
                <div className="customer-warning-new-hamburger-help">

                    <div className="filter-controls">
                        <button onClick={() => setShowDrawer(true)} className="more-filters-btn">
                            <i className="fa-solid fa-sliders"></i> Filters
                        </button>
                    </div>
                    {/* <div className="import-hamburger" onClick={toggleImport}>
                    <i className="fa-solid fa-ellipsis-vertical"></i>
                </div> */}

                </div>
            </div>
            {/* Search Filter */}
            {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

            {/* Customer Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            {/* <th>Photo</th> */}
                            <th>Name</th>
                            <th>Email</th>
                            <th>ID</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.full_name}</td>
                                    <td>{customer.email}</td>
                                    <td>{customer.user_id}</td>
                                    <td>
                                        <button
                                            onClick={() => toggleActive(index, customer.id)}
                                            className="toggle-btn"
                                        >
                                            <i className={`fa ${customer.status === "Active" ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </button>
                                    </td>

                                    <td>
                                        {new Date(customer.createdAt).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            onClick={() => navigate(`/activity/${customer.user_id}`)}
                                            className="toggle-btn"
                                            title="View activity"
                                            aria-label="View activity"
                                        >
                                            <i className="fa-solid fa-eye"></i>
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => deleteUserRecord(customer)}
                                            className="toggle-btn"
                                            title="Delete user"
                                            aria-label="Delete user"
                                            style={{ marginLeft: 8, color: "#b91c1c" }}
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center' }}>No Users found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p>No Users Available</p>
                ) : (
                    currentData.map((userRecord, index) => (
                        <div className="ecom-responsive-card"
                            key={index}>

                            <div className="ecom-responsive-header">
                                <p>{userRecord.user_id || "—"}</p>
                                <p>{new Date(userRecord.createdAt).toLocaleString("en-IN", {
                                    timeZone: "Asia/Kolkata",
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                })}</p>

                            </div>

                            <div className="ecom-responsive-body">
                                <div className="ecom-responsive-left">
                                    <h2>{userRecord.full_name || "Name Not Provided"}</h2>
                                    <p>{userRecord.email || "N/A"}</p>
                                    <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                                        <button
                                            type="button"
                                            className="toggle-btn"
                                            onClick={() => navigate(`/activity/${userRecord.user_id}`)}
                                        >
                                            <i className="fa-solid fa-eye" /> Activity
                                        </button>
                                        <button
                                            type="button"
                                            className="toggle-btn"
                                            style={{ color: "#b91c1c" }}
                                            onClick={() => deleteUserRecord(userRecord)}
                                        >
                                            <Trash2 size={14} style={{ verticalAlign: "middle" }} /> Delete
                                        </button>
                                    </div>
                                </div>

                                {/* <div className="ecom-responsive-right">
                                    <h4>₹ {userRecord.amount?.toFixed?.(2) || "0.00"}</h4>
                                    {userRecord?.


                                        receipt ? (
                                        <button>
                                            userRecord.receipt.startsWith("https://drive.google.com") ? (
                                            <a href={userRecord.receipt} target="_blank" rel="noopener noreferrer">View receipt</a>
                                            ) : (
                                            <a href={`${url}/Images/userRecord/${userRecord.receipt}`} target="_blank" rel="noopener noreferrer">View receipt</a>
                                            )

                                        </button>
                                    ) : null}
                                </div> */}
                            </div>
                        </div>
                    ))
                )}

            </div>
            {totalPages > 1 && (

                <div className="pagination">
                    {/* First Page */}
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>

                    {/* Previous Page */}
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>

                    {/* Current Page Number Only */}
                    <button className="pagination-btn active">
                        {currentPage}
                    </button>

                    {/* Next Page */}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>

                    {/* Last Page */}
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}
            <FilterDrawer />
        </>
    );
};

export default UserRecords;
